<template>
    <div>
        <div class="work_index_item">
            <p>{{applistname}}</p>
            <ul>
               <router-link class="work_option" v-for="(item,index) in applist" :key="index" :to="item.goto">
                    <img :src=item.currentSrc>
                    <div>{{item.name}}</div>
               </router-link> 
            </ul>
      </div>   
    </div>
</template>

<script>
export default {
    name: 'JianzhibeiWorkIndexItem',

    data() {
        return {
       
        };
    },
   props:{
    applistname:{
      type: String,
       required:true 
    },
     applist:{
       type: Array,
       default: function () {
        return [];
      },
       required:true
     }

   },

    mounted() {
        
    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.work_index_item{
      margin-top: 38px;
 }
 .work_index_item ul{
      margin-top: 23px;
      display: flex;
 }
 .work_index_item ul .work_option{
      width: 180px;
      height: 60px;
      margin-right: 19px;
      border: 1px solid #CCCCCC;
      border-radius: 10px;
      display: flex;
 }
 .work_index_item ul .work_option img{
      height: 39px;
      width: 39px;
      margin-top: 11px;
      margin-left: 13px;
 }
 .work_index_item ul .work_option div{
      margin-left: 20px;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      user-select:none;
      color: #181818;
 }

</style>